import { render, staticRenderFns } from "./AllowanceSummaryReportTable.vue?vue&type=template&id=776246a2"
import script from "./AllowanceSummaryReportTable.vue?vue&type=script&lang=js"
export * from "./AllowanceSummaryReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports